module.exports = __webpack_public_path__ + "img/flammables.4c4dea64.png";